import { useNavigate, useSearchParams } from "react-router-dom";
import {
  SuppliersListPage as SuppliersListPageView,
  type SuppliersListFilters,
} from "@/components/SuppliersListPage";

export function SuppliersListPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultFilters: SuppliersListFilters = {
    name: searchParams.get("name") ?? undefined,
    email: searchParams.get("email") ?? undefined,
  };

  function handleFiltersChange(filters: SuppliersListFilters) {
    const next = new URLSearchParams();
    if (filters.name) next.set("name", filters.name);
    if (filters.email) next.set("email", filters.email);
    setSearchParams(next, { replace: true });
  }

  return (
    <SuppliersListPageView
      onSupplierClick={(id) => navigate(`/suppliers/${id}`)}
      defaultFilters={defaultFilters}
      onFiltersChange={handleFiltersChange}
    />
  );
}
